import React from "react";
import TextInput from "../../../component/element/forms/TextInput";
import { useAppDispatch } from "../../../store";
// import { useAppDispatch, useAppSelector } from "../../../store";
import { edit_category } from "../../../services/apis/blog";
import Modal from "../../../component/ui/modal";
import { ICategory } from "../../../store/types/blog";

type IEditCategory = {
  data: ICategory;
  show: boolean;
  onHandler: () => void;
};

const EditCategory: React.FC<IEditCategory> = ({ show, data, onHandler }) => {
  const dispatch = useAppDispatch();
  // const loading = useAppSelector(({ blog }) => blog.loading);
  const [form, formSet] = React.useState<ICategory>({
    name: "",
    id: "",
  });

  const onLoad = React.useCallback(() => {
    if (data.name && data.id) {
      const { name, id } = data;
      formSet({ id, name });
    }
  }, [data]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <Modal
      title="Edit Category"
      open={show}
      onClose={onHandler}
      onOkClick={() => edit_category(form, dispatch)}
      // confirmLoading={!!loading}
      // onClose={onModal}
      // onOk={() => edit_category(form, dispatch)}
    >
      <div className="mb-6">
        <TextInput
          label="Category Name"
          name="name"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            formSet((prev) => ({ ...prev, name: e.target.value }))
          }
          placeholder="Enter Category Name"
          type="text"
          value={form.name}
        />
      </div>
    </Modal>
  );
};

export default EditCategory;
